import React, { useCallback, useContext } from 'react'
import { Snackbar, IconInfo } from 'blocket-ui'
import PropTypes from 'prop-types'

import { Context } from './ArchivedAdNotificationProvider'

const ArchivedAdNotification = ({ className }) => {
  const { visible, close } = useContext(Context)

  const wrapperRef = useCallback((node) => {
    if (node) {
      window.scrollTo(0, node.offsetTop)
    }
  }, [])

  return visible ? (
    <div ref={wrapperRef} className={className}>
      <Snackbar
        type="info"
        subject="Annonsen finns inte längre"
        description="Kolla gärna bland liknande annonser"
        active
        icon={<IconInfo width={24} height={24} color="#4182c3" />}
        onCloseBtn={close}
      />
    </div>
  ) : null
}

ArchivedAdNotification.propTypes = {
  className: PropTypes.string,
}

export default ArchivedAdNotification
